import { Coordinate2D, VisNode } from '@/types'

export interface XYVisNode extends VisNode {
  key: string
  xAxisTickKey: string
  yAxisValue: number
}

export interface AxisTick {
  value: string | number
  label: string
  position: Coordinate2D
}

export interface AxisLabel {
  label: string
  position: Coordinate2D
}

export interface AxisProps {
  startPoint: Coordinate2D
  endPoint: Coordinate2D
  label?: string
  ticks?: AxisTick[]
}

export interface XAxisProps extends AxisProps {}

export interface YAxisProps extends AxisProps {
  xOffset: number
}

export enum Axes {
  x,
  y,
}
